import React from 'react';
import { Box, Typography, Grid, makeStyles } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import { Package as PackageIcon, List as ListIcon } from 'react-feather';
import Button from '@material-ui/core/Button';
import PlaceIcon from '@material-ui/icons/Place';
import { NavLink as RouterLink, useNavigate } from 'react-router-dom';
import { getShipperLogoPath } from "helpers";
import ParcelshopIframe from 'modules/ParcelshopIframe';

const SHIPPERS_NO_PARCELSHOP = ['123', 'QDL', 'SDS'];
const SHIPPER_CLAIM_ASSISTANT = 'PACKETA';

const useStyles = makeStyles(() => ({
    root: {},
    button: {},
}));

const ActionButton = ({ startIcon, children, color = 'secondary', ...props }) => (
    <Button variant="contained" color={color} size="small" fullWidth startIcon={startIcon} {...props}>
        {children}
    </Button>
);

const NewPackageShipper = ({ shipper, handlePackageClose, pickup, packageType = 'standard' }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const shortcut = shipper.shortcut.toUpperCase();
    const showParcelshop = !SHIPPERS_NO_PARCELSHOP.includes(shortcut);
    const showClaimAssistant = shortcut === SHIPPER_CLAIM_ASSISTANT;

    const onSelectParcelshop = (parcelshop) => {
        if (parcelshop) {
            handlePackageClose();
            navigate(`/app/package/newparcelshop/${shipper.id}/${parcelshop.id}`, { state: { pickup, packageType } });
        }
    };

    const toAddressPath = `/app/package/new/${shipper.id}`;
    const toAddressState = { pickup, packageType };
    const goToImport = () => {
        navigate('/app/package/import', { state: { shipper, pickup } });
        handlePackageClose();
    };

    const toAddressLinkButton = (
        <ActionButton
            className={classes.button}
            startIcon={<PackageIcon />}
            component={RouterLink}
            to={{ pathname: toAddressPath }}
            state={toAddressState}
            onClick={handlePackageClose}
        >
            {t('button.to_address')}
        </ActionButton>
    );
    const importButton = (
        <ActionButton className={classes.button} startIcon={<ListIcon />} onClick={goToImport}>
            {t('button.import')}
        </ActionButton>
    );
    const parcelshopButton = showParcelshop && (
        <ActionButton className={classes.button} startIcon={<PlaceIcon />} onClick={() => ParcelshopIframe.Widget.open(onSelectParcelshop, { shipper_id: shipper.id })}>
            {t('button.parcelshop')}
        </ActionButton>
    );
    const claimAssistantButton = showClaimAssistant && (
        <>
            <Box p={1} />
            <ActionButton className={classes.button} color="primary" onClick={() => { handlePackageClose(); navigate('/app/package/claimassistant', { state: shipper }); }}>
                {t('button.claim_assistant')}
            </ActionButton>
        </>
    );

    return (
        <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={6}>
                <Typography variant="h1" component="h2" color="primary" align="center">
                    <img width={150} src={getShipperLogoPath(shipper.shortcut)} alt={shipper.shortcut} />
                </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                {toAddressLinkButton}
                <Box p={1} />
                {parcelshopButton}
                <Box p={1} />
                {importButton}
                {claimAssistantButton}
            </Grid>
        </Grid>
    );
};

export default NewPackageShipper;
